import React, { useState } from "react";
import { PRODUCT_API , BULK_CREATE} from "../../../data/api";
import * as XLSX from "xlsx";

const AddProduct = () => {
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);

  const [formData, setFormData] = useState({
    vendorId: "",
    productName: "",
    productType: "",
    price: "",
    quantity: "",
    status: "",
    capacityKG: "",
    speedMPS: "",
    machineRoomType: "",
    doorType: "",
    floorsSupported: "",
    warrantyYears: "",
    powerConsumption: "",
    description: "",
    features: "",
    isCustomizable: true,
    imageURLs: [],
  });

  const [previewImages, setPreviewImages] = useState([]);

const handleBulkUpload = async () => {
  if (!bulkFile) {
    alert("Please choose a file");
    return;
  }

  let jsonData = [];

  try {
    if (bulkFile.name.endsWith(".csv")) {
      const text = await bulkFile.text();
      const rows = text
        .split("\n")
        .filter(r => r.trim() !== "")
        .map(row => row.split(","));
      const headers = rows[0].map(h => h.trim());
      jsonData = rows.slice(1).map(r =>
        Object.fromEntries(r.map((v, i) => [headers[i], v.trim()]))
      );
    } else {
      const data = await bulkFile.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      jsonData = XLSX.utils.sheet_to_json(sheet);
    }

    const formattedData = jsonData.map(item => ({
      VendorId: Number(item.vendorId),
      ProductName: item.productName,
      ProductType: item.productType,
      Price: Number(item.price),
      Quantity: Number(item.quantity),
      Status: item.status,
      CapacityKG: Number(item.capacityKG),
      SpeedMPS: Number(item.speedMPS),
      MachineRoomType: item.machineRoomType,
      DoorType: item.doorType,
      FloorsSupported: Number(item.floorsSupported),
      WarrantyYears: Number(item.warrantyYears),
      PowerConsumption: item.powerConsumption,
      Description: item.description,
      Features: item.features,
      IsCustomizable: item.isCustomizable === "true" || item.isCustomizable === true,
      ImageURLs: item.imageURLs || []
    }));

    console.log("Formatted Data Sent to Backend:", formattedData); // 🔥 Log data

    const res = await fetch(PRODUCT_API.BULK_CREATE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ requests: formattedData }),
    });

    if (res.ok) {
      alert("Bulk Upload Successful");
      setShowBulkModal(false);
      setBulkFile(null);
    } else {
      // Try to parse backend error JSON
      let errText;
      try {
        const errJson = await res.json();
        errText = JSON.stringify(errJson);
      } catch {
        errText = await res.text();
      }
      console.error("Bulk Upload Error Response:", errText); // 🔥 Log error
      alert("Bulk upload failed: " + errText);
    }
  } catch (error) {
    console.error("Error Parsing File or Sending Request:", error); // 🔥 Log error
    alert("Error parsing file: " + error.message);
  }
};



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const imageNames = files.map((f) => f.name);
    const preview = files.map((f) => URL.createObjectURL(f));

    setFormData({
      ...formData,
      imageURLs: [...formData.imageURLs, ...imageNames],
    });

    setPreviewImages([...previewImages, ...preview]);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        vendorId: Number(formData.vendorId),
        price: Number(formData.price),
        quantity: Number(formData.quantity),
        capacityKG: Number(formData.capacityKG),
        speedMPS: Number(formData.speedMPS),
        floorsSupported: Number(formData.floorsSupported),
        warrantyYears: Number(formData.warrantyYears),
      };

      const res = await fetch(PRODUCT_API.CREATE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        
      });
      console.log(res);

      if (res.ok) {
        alert("Product Added Successfully!");

        setFormData({
          vendorId: "",
          productName: "",
          productType: "",
          price: "",
          quantity: "",
          status: "",
          capacityKG: "",
          speedMPS: "",
          machineRoomType: "",
          doorType: "",
          floorsSupported: "",
          warrantyYears: "",
          powerConsumption: "",
          description: "",
          features: "",
          isCustomizable: true,
          imageURLs: [],
        });

        setPreviewImages([]);
      } else {
        alert("Failed to create product");
      }
    } catch (error) {
      alert("Error creating product");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-semibold mb-6">Add New Product</h1>

      <button
  onClick={() => setShowBulkModal(true)}
  className="mb-4 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
>
  Bulk Upload 📦
</button>


      <div className="bg-white p-6 shadow rounded-lg grid grid-cols-1 md:grid-cols-2 gap-5">

        {/* Vendor ID */}
        <div>
          <label className="font-medium text-gray-700">Vendor ID</label>
          <input
            type="number"
            name="vendorId"
            value={formData.vendorId}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg mt-1 bg-gray-50 focus:ring focus:ring-blue-300"
          />
        </div>

        {/* Product Name (visible if Vendor ID filled) */}
        {formData.vendorId && (
          <div>
            <label className="font-medium text-gray-700">Product Name</label>
            <input
              name="productName"
              value={formData.productName}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50 focus:ring-blue-300"
            />
          </div>
        )}

        {/* Product Type */}
        {formData.productName && (
          <div>
            <label className="font-medium text-gray-700">Product Type</label>
            <input
              name="productType"
              value={formData.productType}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50 focus:ring-blue-300"
            />
          </div>
        )}
        

        {/* Price */}
        {formData.productType && (
          <div>
            <label className="font-medium text-gray-700">Price</label>
            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Quantity */}
        {formData.price && (
          <div>
            <label className="font-medium text-gray-700">Quantity</label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Status */}
        {formData.quantity && (
          <div>
            <label className="font-medium text-gray-700">Status</label>
            <input
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Capacity */}
        {formData.status && (
          <div>
            <label className="font-medium text-gray-700">Capacity (KG)</label>
            <input
              type="number"
              name="capacityKG"
              value={formData.capacityKG}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Speed */}
        {formData.capacityKG && (
          <div>
            <label className="font-medium text-gray-700">Speed (MPS)</label>
            <input
              type="number"
              name="speedMPS"
              value={formData.speedMPS}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Machine Room */}
        {formData.speedMPS && (
          <div>
            <label className="font-medium text-gray-700">Machine Room Type</label>
            <input
              name="machineRoomType"
              value={formData.machineRoomType}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Door Type */}
        {formData.machineRoomType && (
          <div>
            <label className="font-medium text-gray-700">Door Type</label>
            <input
              name="doorType"
              value={formData.doorType}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Floors */}
        {formData.doorType && (
          <div>
            <label className="font-medium text-gray-700">Floors Supported</label>
            <input
              type="number"
              name="floorsSupported"
              value={formData.floorsSupported}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Warranty */}
        {formData.floorsSupported && (
          <div>
            <label className="font-medium text-gray-700">Warranty Years</label>
            <input
              type="number"
              name="warrantyYears"
              value={formData.warrantyYears}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Power */}
        {formData.warrantyYears && (
          <div>
            <label className="font-medium text-gray-700">Power Consumption</label>
            <input
              name="powerConsumption"
              value={formData.powerConsumption}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50"
            />
          </div>
        )}

        {/* Description */}
        {formData.powerConsumption && (
          <div className="col-span-2">
            <label className="font-medium text-gray-700">Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50 h-24"
            />
          </div>
        )}

        {/* Features */}
        {formData.description && (
          <div className="col-span-2">
            <label className="font-medium text-gray-700">Features</label>
            <textarea
              name="features"
              value={formData.features}
              onChange={handleChange}
              className="w-full p-2 border rounded-lg mt-1 bg-gray-50 h-24"
            />
          </div>
        )}

        {/* Customizable */}
        {formData.features && (
          <div>
            <label className="font-medium text-gray-700">Customizable</label>
            <input
              type="checkbox"
              name="isCustomizable"
              checked={formData.isCustomizable}
              onChange={handleChange}
              className="ml-2"
            />
          </div>
        )}

        {/* Upload Images */}
        {formData.features && (
          <div className="col-span-2 flex justify-end">
            <div className="text-right">
              <label className="font-medium text-gray-700 block mb-1">
                Product Images
              </label>

              <label className="px-4 py-2 bg-blue-600 text-white rounded-md cursor-pointer hover:bg-blue-700 transition shadow">
                Upload Images 📁
                <input
                  type="file"
                  multiple
                  onChange={handleImageUpload}
                  className="hidden"
                />
              </label>
            </div>
          </div>
        )}

        {/* Preview */}
        {previewImages.length > 0 && (
          <div className="col-span-2 flex gap-4 flex-wrap mt-2">
            {previewImages.map((src, index) => (
              <img
                key={index}
                src={src}
                className="w-24 h-24 rounded-lg border object-cover"
              />
            ))}
          </div>
        )}

        {/* Submit Button (Visible Only At Last) */}
        {formData.imageURLs.length > 0 && (
          <div className="col-span-2 flex justify-end">
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md font-semibold shadow"
              onClick={handleSubmit}
            >
              Add Product ✔
            </button>
          </div>
        )}

        {showBulkModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white w-[420px] rounded-lg shadow-lg p-6 relative">

      <h2 className="text-xl font-semibold mb-4">Bulk Upload Products</h2>

      {/* Download format */}
      <a
        href="/bulk-product-format.xlsx"
        download
        className="inline-block mb-4 text-blue-600 underline"
      >
        Download Excel Format ⬇️
      </a>

      {/* Choose file */}
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={(e) => setBulkFile(e.target.files[0])}
        className="mb-4"
      />

      {/* Buttons */}
      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowBulkModal(false)}
          className="px-4 py-2 border rounded"
        >
          Cancel
        </button>

        <button
          onClick={handleBulkUpload}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Upload ✔
        </button>
      </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
};

export default AddProduct;


export const DownloadCSV = () => {
  const downloadCSV = () => {
    const csvContent = `vendorId,productName,productType,price,quantity,status,capacityKG,speedMPS,machineRoomType,doorType,floorsSupported,warrantyYears,powerConsumption,description,features,isCustomizable,imageURLs
21,Product1,TypeA,1000,5,available,100,2,RoomA,DoorA,2,1,50W,Description1,Feature1,true,image1.jpg
22,Product2,TypeB,2000,10,available,200,3,RoomB,DoorB,3,2,60W,Description2,Feature2,false,image2.jpg
23,Product3,TypeC,3000,15,available,150,2.5,RoomC,DoorC,4,3,70W,Description3,Feature3,true,image3.jpg
24,Product4,TypeD,4000,20,available,120,1.5,RoomD,DoorD,5,2,80W,Description4,Feature4,false,image4.jpg
25,Product5,TypeE,5000,25,available,180,2.2,RoomE,DoorE,6,4,90W,Description5,Feature5,true,image5.jpg
26,Product6,TypeF,6000,30,available,160,3.1,RoomF,DoorF,2,1,100W,Description6,Feature6,false,image6.jpg
27,Product7,TypeG,7000,35,available,140,2.8,RoomG,DoorG,3,2,110W,Description7,Feature7,true,image7.jpg
28,Product8,TypeH,8000,40,available,130,2.6,RoomH,DoorH,4,3,120W,Description8,Feature8,false,image8.jpg
29,Product9,TypeI,9000,45,available,170,3,RoomI,DoorI,5,2,130W,Description9,Feature9,true,image9.jpg
30,Product10,TypeJ,10000,50,available,190,2.9,RoomJ,DoorJ,6,3,140W,Description10,Feature10,false,image10.jpg
31,Product11,TypeK,11000,55,available,200,3.2,RoomK,DoorK,7,4,150W,Description11,Feature11,true,image11.jpg`;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "products.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="p-6">
      <button
        onClick={downloadCSV}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Download Products CSV
      </button>
    </div>
  );
};